import React from 'react';

import Basic, { ShowcaseTemplateProps } from '../Basic';

import classes from './HoneyCream.module.scss'

export default function HoneyCream({ showcase, offers, linksByOfferId }: ShowcaseTemplateProps): JSX.Element {
  return (
    <Basic showcase={showcase} offers={offers} linksByOfferId={linksByOfferId} classes={classes} />
  );
}
